module.exports = __webpack_public_path__ + "img/symptoms.1fc9def6.svg";